import { Path } from 'react-hook-form';

export const HEADER_MAX_LENGTH = 25;
export const DESCRIPTION_MAX_LENGTH = 200;

export type IHeaderContent = {
  header: string;
  subHeader: string;
};

export type SubmissionStepKey =
  | 'startSubmissionForm'
  | 'reviewSubmissionInformation'
  | 'reviewAuthorInformation'
  | 'submissionPreferences';

export type AuthorSubmissionFormConfig = Record<
  SubmissionStepKey,
  IHeaderContent
>;

export type ISubmissionStepContentForm = {
  config: {
    cms: {
      authorSubmissionForm: AuthorSubmissionFormConfig;
    };
  };
};

export type ISubmissionStepContentPayload = {
  data?: Record<string, never>;
  config: {
    cms: {
      authorSubmissionForm: Partial<AuthorSubmissionFormConfig>;
    };
  };
};

export type SubmissionStepConfig = {
  key: SubmissionStepKey;
  title: string;
};

export const SUBMISSION_STEP_CONFIGS = [
  {
    key: 'startSubmissionForm',
    title: 'Upload Step'
  },
  {
    key: 'reviewSubmissionInformation',
    title: 'Step One'
  },
  {
    key: 'reviewAuthorInformation',
    title: 'Step Two'
  },
  {
    key: 'submissionPreferences',
    title: 'Step Three'
  }
] as const satisfies ReadonlyArray<SubmissionStepConfig>;

export const getStepFieldPath = (
  stepKey: SubmissionStepKey,
  field: keyof IHeaderContent
): Path<ISubmissionStepContentForm> =>
  `config.cms.authorSubmissionForm.${stepKey}.${field}` as Path<ISubmissionStepContentForm>;

export const buildSubmissionStepDefaultValues = (
  authorSubmissionForm?: Partial<
    Record<SubmissionStepKey, Partial<IHeaderContent> | undefined>
  >
): ISubmissionStepContentForm => ({
  config: {
    cms: {
      authorSubmissionForm: {
        startSubmissionForm: {
          header: authorSubmissionForm?.startSubmissionForm?.header ?? '',
          subHeader: authorSubmissionForm?.startSubmissionForm?.subHeader ?? ''
        },
        reviewSubmissionInformation: {
          header:
            authorSubmissionForm?.reviewSubmissionInformation?.header ?? '',
          subHeader:
            authorSubmissionForm?.reviewSubmissionInformation?.subHeader ?? ''
        },
        reviewAuthorInformation: {
          header: authorSubmissionForm?.reviewAuthorInformation?.header ?? '',
          subHeader:
            authorSubmissionForm?.reviewAuthorInformation?.subHeader ?? ''
        },
        submissionPreferences: {
          header: authorSubmissionForm?.submissionPreferences?.header ?? '',
          subHeader:
            authorSubmissionForm?.submissionPreferences?.subHeader ?? ''
        }
      }
    }
  }
});

export const buildSubmissionStepPayload = (
  stepKey: SubmissionStepKey,
  stepValue: IHeaderContent
): ISubmissionStepContentPayload => ({
  data: {},
  config: {
    cms: {
      authorSubmissionForm: {
        [stepKey]: stepValue
      }
    }
  }
});
